const Genesis = require("../Genesis.js");
import { LazyLoadComponent } from '../Shared/LazyLoad/LazyLoadComponent';

export class ISiteMobileServiceRequestMyServiceRequestsPage {

    private lazyLoadComponent: LazyLoadComponent = new LazyLoadComponent({
        ListContainer: 'ServiceRequest-Content',
        LoadingStatus: 'Loading-Status',
        BtnLoadMore: 'btnLoadMore',
        RequestUrl: Genesis.url('/ServiceRequest/ServiceRequestList'),
        FilterForm: "",
        DateFilterCol: "",
        HttpMethod: "GET",
        ScrollTopBtn: "scrollTopBtn"
    });

    constructor() {
    }

    public Init() {
    }
};